<template>
  <nav class="navbar fixed-top navbar-light navbar-expand-md py-0">
    <router-link class="navbar-brand d-block d-sm-none text-white py-0" to="/">WMC</router-link>
    <router-link class="navbar-brand d-none d-sm-block d-md-none text-white py-0" to="/">Wanesy Management Center</router-link>

    <button id="mobileMenuButton" class="navbar-toggler navbar-dark d-block d-md-none border-0" type="button" @click.stop.prevent="toggleSidebar">
      <span class="navbar-toggler-icon" />
    </button>

    <div class="navbar-collapse h-100 d-none d-md-block justify-content-between">
      <alarms-notifications class="nav-item" />

      <ul class="navbar-nav">
        <selection :selection="$store.getters.gatewaysSelection"
                   link="/selection/gateways"
                   type="gateway"
        />
        <selection :selection="$store.getters.endDevicesSelection"
                   link="/selection/end-devices"
                   type="enddevice"
        />

        <notifications />

        <b-dropdown variant="link" no-caret right>
          <div slot="button-content" class="user-menu d-flex align-items-center">
            <avatar :name="authenticatedUser.login"
                    :picture-url="authenticatedUser.avatar"
                    size="sm"
            />

            <div class="d-none d-md-inline-block">
              <div v-if="authenticatedUser.firstName && authenticatedUser.lastName" class="user-menu-user">{{ authenticatedUser.firstName }} {{ authenticatedUser.lastName }}</div>
              <div v-else class="user-menu-user">{{ authenticatedUser.login }}</div>
              <div class="user-menu-customer">{{ authenticatedUserCustomer.name }}</div>
            </div>
          </div>

          <b-dropdown-item id="navbarProfileLink" :to="'/profile/' + authenticatedUser.id">{{ $t('navbar:profile') | capitalize }}</b-dropdown-item>
          <b-dropdown-item v-if="isRole.superAdmin" id="navbarSettingsLink" to="/settings">{{ $t('navbar:settings') | capitalize }}</b-dropdown-item>
          <b-dropdown-item v-if="isRole.superAdmin" id="navbarActionsLink" to="/actions">{{ $t('navbar:actions') | capitalize }}</b-dropdown-item>
          <b-dropdown-item id="navbarDocsLink" :href="$store.getters.constants.docsUrl" target="_blank">{{ $t('navbar:documentations') | capitalize }}</b-dropdown-item>
          <b-dropdown-item id="navbarAboutLink" to="/about">{{ $t('navbar:about') | capitalize }}</b-dropdown-item>
          <b-dropdown-divider />

          <b-dropdown-item id="logout" @click="logout()">{{ $t('navbar:signOut') | capitalize }}</b-dropdown-item>
        </b-dropdown>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import eventBus from '@/modules/eventBus'

import AlarmsNotifications from './AlarmsNotifications'
import Selection from './Selection'
import Notifications from './Notifications'

import BDropdown from 'bootstrap-vue/es/components/dropdown/dropdown'
import BDropdownItem from 'bootstrap-vue/es/components/dropdown/dropdown-item'
import BDropdownDivider from 'bootstrap-vue/es/components/dropdown/dropdown-divider'

export default {
  components: { AlarmsNotifications, Selection, Notifications, BDropdown, BDropdownItem, BDropdownDivider },

  data: () => {
    return {
      timeoutLastBscEventsCounters: null,
      timeoutLastRncEventsCounters: null,
      timeoutLastLnsEventsCounters: null
    }
  },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['authenticatedUser', 'authenticatedUserCustomer'])
  },

  methods: {
    toggleSidebar () {
      eventBus.$emit('sidebar:toggle')
    },

    // Logout from app
    logout () {
      // And logout
      this.$api.logout()
    }
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .navbar {
    height: $navbar-height;
    margin-left: 0;
    background-color: $primary;

    @media (min-width: $grid-breakpoint-md) {
      margin-left: $sidebar-width;
      background-color: $white;
    }

    .user-menu {
      text-transform: none;

      .user-menu-user,
      .user-menu-customer {
        max-width: 120px;
        margin-left: 7px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .user-menu-user {
        font-weight: 500;
      }

      .user-menu-customer {
        font-size: 80%;
        font-style: italic;
        line-height: 10px;
        color: $gray-500;
      }
    }
  }
</style>
